var map = {
	"./1985_GDP_totalRate.png": 191,
	"./1986_GDP_totalRate.png": 192,
	"./1987_GDP_totalRate.png": 193,
	"./1988_GDP_totalRate.png": 194,
	"./1989_GDP_totalRate.png": 195,
	"./1990_GDP_totalRate.png": 196,
	"./1991_GDP_totalRate.png": 197,
	"./1992_GDP_totalRate.png": 198,
	"./1993_GDP_totalRate.png": 199,
	"./1994_GDP_totalRate.png": 200,
	"./1995_GDP_totalRate.png": 201,
	"./1996_GDP_totalRate.png": 202,
	"./1997_GDP_totalRate.png": 203,
	"./1998_GDP_totalRate.png": 204,
	"./1999_GDP_totalRate.png": 205,
	"./2000_GDP_totalRate.png": 206,
	"./2001_GDP_totalRate.png": 207,
	"./2002_GDP_totalRate.png": 208,
	"./2003_GDP_totalRate.png": 209,
	"./2004_GDP_totalRate.png": 210,
	"./2005_GDP_totalRate.png": 211,
	"./2006_GDP_totalRate.png": 212,
	"./2007_GDP_totalRate.png": 213,
	"./2008_GDP_totalRate.png": 214,
	"./2009_GDP_totalRate.png": 215,
	"./2010_GDP_totalRate.png": 216,
	"./2011_GDP_totalRate.png": 217,
	"./2012_GDP_totalRate.png": 218,
	"./2013_GDP_totalRate.png": 219,
	"./2014_GDP_totalRate.png": 220,
	"./2015_GDP_totalRate.png": 221
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 190;